import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class LightDiagnosticCalculatePlanForm extends BaseModel {
  billingPlanId?: string;
  price?: number;
  yearlyPrice?: number;
  isSaasBilling?: boolean;
  chargeRecurringFee?: boolean;

  constructor(model: Partial<LightDiagnosticCalculatePlanForm> = {}) {
    super();

    this.billingPlanId = model.billingPlanId;
    this.price = model.price;
    this.yearlyPrice = model.yearlyPrice;
    this.isSaasBilling = model.isSaasBilling;
    this.chargeRecurringFee = model.chargeRecurringFee;
  }
}
